export const UnixToDate = (input) => {
  let date;

  if (typeof input === "number") {
    date = new Date(input * 1000);
  }
  else if (typeof input === "string") {
    date = new Date(input);
  }
  else if (input instanceof Date) {
    date = input;
  }
  else {
    return "Invalid date";
  }

  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")}/${date.getFullYear()} ${String(
    date.getHours()
  ).padStart(2, "0")}:${String(date.getMinutes()).padStart(
    2,
    "0"
  )}:${String(date.getSeconds()).padStart(2, "0")}`;

  return formattedDate;
};